import { render, staticRenderFns } from "./Chlorine.vue?vue&type=template&id=1142c6d6&scoped=true&"
import script from "./Chlorine.vue?vue&type=script&lang=js&"
export * from "./Chlorine.vue?vue&type=script&lang=js&"
import style0 from "./Chlorine.vue?vue&type=style&index=0&id=1142c6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1142c6d6",
  null
  
)

export default component.exports